module.exports = "img/icon-invite-people.d82f491.svg";